/* eslint-disable no-console */
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Auth } from 'aws-amplify';
import './nav.scss';
import {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import classNames from 'classnames';
import clearLocalIndexedDb from '../../../../utilities/clearIndexDb';
import { ReactComponent as PurpleArrowSvg } from '../../../../assets/svgs/purple-arrow.svg';

const Nav = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpened, setIsMobileMenuOpened] = useState(false);

  const signout = useCallback(async () => {
    try {
      await Auth.signOut();
      dispatch({ type: 'accounts/setCustomerId', payload: null });
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('anonymousId');
      clearLocalIndexedDb();
      window?.pubSub?.publish?.(
        'onCartUpdate', { lineItems: [] },
      );
      dispatch({ type: 'accounts/setCustomerId', payload: false });
      navigate('/');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }, [dispatch, navigate]);

  const navItems = useMemo(() => [
    { title: 'Order History', description: 'View & track orders', link: '/orders' },
    { title: 'Personal Info', description: 'Edit your name, email & password', link: '/profile' },
    { title: 'Addresses', description: 'Edit or add shipping addresses', link: '/addresses' },
    { title: 'Sign out', onClick: signout },
  ], [signout]);

  const activeNavItem = navItems.find((navItem) => location.pathname.includes(navItem.link));

  const handleMenuItemClick = useCallback((navItem) => {
    if (navItem.onClick) {
      navItem.onClick();
    } else {
      navigate(navItem.link);
    }
    setIsMobileMenuOpened(false);
  }, [navigate]);

  useEffect(() => {
    if (isMobileMenuOpened) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpened]);

  return (
    <nav className="accounts-nav">
      <div className="accounts-nav__title">My Account</div>
      <ul className="accounts-nav__items">
        {navItems.map((item) => (
          <li key={item.title}>
            {item.link ? (
              <NavLink
                to={item.link}
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                {item.title}
              </NavLink>
            )
              : <button onClick={item.onClick} type="button">{item.title}</button>}
          </li>
        ))}
      </ul>

      <button
        type="button"
        className="accounts-nav__mobile__link"
        onClick={() => setIsMobileMenuOpened((prev) => !prev)}
      >
        {activeNavItem?.title}
        <PurpleArrowSvg className={classNames({ 'up-arrow': isMobileMenuOpened })} />
      </button>

      {isMobileMenuOpened && (
        <div className="accounts-nav__mobile__menu">
          {navItems.map((navItem) => (
            <button type="button" key={navItem.title} onClick={() => handleMenuItemClick(navItem)}>
              <div>
                <p className="accounts-nav__mobile__menu__item--p1">
                  {navItem.title}
                </p>
                <p className="accounts-nav__mobile__menu__item--p2">
                  {navItem.description}
                </p>
              </div>
              <PurpleArrowSvg className="right-arrow" />
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Nav;
